
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  PrefillFreelancerVatNumberResponse,
} from '../models';
import {
    PrefillFreelancerVatNumberResponseFromJSON,
    PrefillFreelancerVatNumberResponseToJSON,
} from '../models';

export interface PrefillFreelancerVatNumberRequest {
    file: Blob;
}

/**
 * 
 */
export class FreelancerVatNumberPrefillApi extends runtime.BaseAPI {

    /**
     * Accepts a CSV file with one freelancer company id per line. For each id, fires a command that looks up the freelancer\'s VAT number from legal information (INPI in priority) and, when found, updates the freelancer company. Companies that already have a VAT number are skipped. 
     * Prefill freelancer VAT numbers from legal information, given a CSV of freelancer company ids
          */
    async prefillFreelancerVatNumberRaw(requestParameters: PrefillFreelancerVatNumberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PrefillFreelancerVatNumberResponse>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling prefillFreelancerVatNumber().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request<PrefillFreelancerVatNumberResponse>({
            path: `/compliance/api/admin/freelancer/prefill-vat-number`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (response._data) { response._data=PrefillFreelancerVatNumberResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Accepts a CSV file with one freelancer company id per line. For each id, fires a command that looks up the freelancer\'s VAT number from legal information (INPI in priority) and, when found, updates the freelancer company. Companies that already have a VAT number are skipped. 
     * Prefill freelancer VAT numbers from legal information, given a CSV of freelancer company ids
          */
    async prefillFreelancerVatNumber(requestParameters: PrefillFreelancerVatNumberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PrefillFreelancerVatNumberResponse> {
        const response = await this.prefillFreelancerVatNumberRaw(requestParameters, initOverrides);
        return response._data;
    }

}
